import { render, staticRenderFns } from "./ui-select.vue?vue&type=template&id=1b2820ca&scoped=true"
import script from "./ui-select.vue?vue&type=script&lang=js"
export * from "./ui-select.vue?vue&type=script&lang=js"
import style0 from "./ui-select.vue?vue&type=style&index=0&id=1b2820ca&prod&lang=scss"
import style1 from "./ui-select.vue?vue&type=style&index=1&id=1b2820ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2820ca",
  null
  
)

export default component.exports